import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class LastVisitedProductConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getReferrers(): string[] {
		return this.configService.get((x) => x.core.lastVisitedLobby.referrers, ["google"]);
	}

	getListOfProvidersToReset(): string[] {
		return this.configService.get((x) => x.core.lastVisitedLobby.resetForProviders, []);
	}
}
